import React from 'react';
import { IconButton, SvgIcon } from '@mui/material';
import { ReactComponent as iconUnCheckBox } from 'assets/images/icons/table/unCheckBox.svg';
import { IconButtonProps } from 'types/icon';

const CampaignCheckBoxUncheck: React.FC<IconButtonProps> = ({
    width = '16px',
    height = '16px',
    color = 'white',
    onClick,
}) => {
    return (
        <IconButton onClick={onClick}>
            <SvgIcon
                component={iconUnCheckBox}
                inheritViewBox
                style={{ width, height, color }}
            />
        </IconButton>
    );
};

export default CampaignCheckBoxUncheck;
